export const ImageConfig = {
    default: "../../../assets/images/file-blank-solid-240.png",
    pdf: "../../../assets/images/file-pdf-solid-240.png",
    png: "../../../assets/images/file-png-solid-240.png",
    css: "../../../assets/images/file-css-solid-240.png"
}